import Dexie, { type Table } from "dexie";
import type { Entry, Subscription, UserSettings } from "@/domain/entities";

export interface SettingsRow extends UserSettings {
  /** Written by versions before the onboarding screen was removed; ignored. */
  onboardingDone?: boolean;
  id: "user";
}

export class UmemoryDatabase extends Dexie {
  declare entries: Table<Entry, string>;
  declare subscriptions: Table<Subscription, string>;
  declare settings: Table<SettingsRow, string>;

  constructor(name = "umemory") {
    super(name);
    const tables = {
      entries: "id, subscriptionId, date, updatedAt, [subscriptionId+date]",
      subscriptions: "id, updatedAt",
      settings: "id",
    };
    this.version(1).stores(tables);
    // v2: entries carry createdAt so several entries of one day keep their order.
    this.version(2)
      .stores(tables)
      .upgrade((tx) =>
        tx.table("entries").toCollection().modify((entry: Entry) => {
          if (!entry.createdAt) entry.createdAt = entry.updatedAt;
        }),
      );
    // v3: subscriptions carry createdAt so scenarios added on the same day keep their order.
    this.version(3)
      .stores(tables)
      .upgrade((tx) =>
        tx.table("subscriptions").toCollection().modify((subscription: Subscription) => {
          if (!subscription.createdAt) subscription.createdAt = subscription.updatedAt;
        }),
      );
  }
}
